import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { WorkbookCompare } from './components/WorkbookCompare';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ink font-sans antialiased" data-id="element-0" data-mp="2wjqhr811w6n6">
      <Hero data-id="element-1" data-mp="2wi5mthatqlos" />
      <main data-id="element-2" data-mp="28ufoscpxzgjl">
        <PainSection data-id="element-3" data-mp="28tw62tsgwo4i" />
        <TomosSection data-id="element-4" data-mp="28te2fc3h77mk" />
        <BonosSection data-id="element-5" data-mp="28sl32w6ujkeg" />
        <PricingSection id="precios" eyebrow="Precio de lanzamiento — cierra en" heading="Elegí tu combo" data-id="element-6" data-mp="28s2ztflro5x1" />
        <WorkbookCompare data-id="element-7" data-mp="3iiweam7rne26" />
        <Testimonials data-id="element-8" data-mp="3ijpbowku4r7n" />
        <Guarantee data-id="element-9" data-mp="3ii4r9zs8ioni" />
        <Faq data-id="element-10" data-mp="3mlaxj7fckftz" />
        <CostSection data-id="element-11" data-mp="3mkrefndynled" />
        <PricingSection id="cierre" eyebrow="Últimas horas al precio de lanzamiento" heading="Empezá hoy tu Reset Integral" data-id="element-12" data-mp="3mk84otygs3bf" />
      </main>
      <Footer data-id="element-13" data-mp="680tswt8a8y" />
    </div>;
}